import { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return (
    <div className="w-full  h-full p-8 bg-background">
      <div className="w-full mx-auto h-full">{children}</div>
    </div>
  );
}

{
  /* <div className="hidden h-full flex-1 flex-col space-y-8 p-8 md:flex">
<div className="flex items-center justify-between space-y-2">
  {children}
</div>
</div> */
}
